import {EditPermissions} from "../../../../../../../shared/models";
import {FormControl, FormGroup} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {required} from "../../../../../../../shared/utils";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";


interface AiAssistantData {
    assistantId: string,
    name: string,
    successNext: string
    successDescription: string
    errorNext: string
    errorDescription: string
}

export const NODE_TYPE = "aiAssistant";

export class AiAssistantNode {

    private menu: {} = {};

    constructor() {
        this.menu = {
            'menuType': NODE_TYPE,
        };
    }

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        const formData: AiAssistantData = this.getFromData(stepData);

        return this.buildForm(formData, editFlows);
    }

    private static getFromData(stepData: { [index: string]: any }): AiAssistantData {

        const menu = stepData?.menu ? stepData?.menu : {};
        const menuParams = menu?.menuParams ? menu?.menuParams : {};
        const results = menu?.results ? menu?.results : {};

        const success = results?.success ? results?.success : {};
        const error = results?.error ? results?.error : {};

        return {
            name: menu?.name ? menu?.name : "",
            assistantId: menuParams?.assistantId ? menuParams?.assistantId : "",
            successNext: success?.next ? success?.next : newStepValue,
            successDescription: success?.description ? success?.description : "Go to next step",
            errorNext: error?.next ? error?.next : newStepValue,
            errorDescription: error?.description ? error?.description : "Unable to connect to AI Assistant",
        };
    }

    private static buildForm(formData: AiAssistantData, editFlows: boolean): FormGroup {
        return new FormGroup({
            name: new FormControl({
                value: formData.name,
                disabled: !editFlows
            }, required('Name')),
            assistantId: new FormControl({
                value: formData.assistantId,
                disabled: !editFlows
            }, required('Assistant')),
            successNext: new FormControl({
                value: formData.successNext,
                disabled: !editFlows
            }),
            successDescription: new FormControl({
                value: formData.successDescription,
                disabled: !editFlows
            }, required('Description')),
            errorNext: new FormControl({
                value: formData.errorNext,
                disabled: !editFlows
            }),
            errorDescription: new FormControl({
                value: formData.errorDescription,
                disabled: !editFlows
            }, required('Description')),
        });
    }

    setNodeData(nodeData: AiAssistantData) {

        const {assistantId, errorDescription, successDescription, successNext, errorNext, name} = nodeData;

        const menuParams = {
            assistantId,
        }

        const results = {
            success: {
                next: successNext,
                description: successDescription
            },
            error: {
                next: errorNext,
                description: errorDescription
            }
        }


        this.menu = {
            ...this.menu,
            name,
            menuParams,
            results
        }
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }


}


